"use strict";
import { List, Map } from "immutable";
import Mailbox from "./mailbox";
const isCacheableEffect = (object) => Map.isMap(object) && object.get("__type__") === "CacheableEffect";
const effect = (...parameters) => {
  const address = _.initial(parameters);
  const task = _.last(parameters);
  return Map({
    __type__: "CacheableEffect",
    task,
    address
  });
};
const perform = (processCacheableAction, effect2) => {
  const mailbox = Mailbox((action) => processCacheableAction(effect2.get("address"), action));
  effect2.getIn(["task", "perform"])(mailbox);
  return true;
};
const CacheableEffects = (...parameters) => List.of(...parameters);
CacheableEffects.isCacheableEffect = isCacheableEffect;
CacheableEffects.effect = effect;
CacheableEffects.perform = perform;
export default CacheableEffects;
